export default "__VITE_ASSET__D6Dsgt2m__"